import React, { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';
import PrivateRoute from '@/components/auth/PrivateRoute';
import { MENU } from '@/constants/menuCodes';

const SchedulePage = lazy(() => import('@/pages/schedule/SchedulePage'));

/**
 * 일정·메모관리 라우트.
 *
 * 세 메뉴가 같은 화면을 scope 만 바꿔 쓴다.
 * menuId 는 마이그레이션 031 에서 고정한 번호다(권한 검사가 id 로 이뤄진다).
 */
const scheduleRoutes = [
  // /schedule 은 메뉴 트리의 네임스페이스일 뿐이라 개인일정으로 보낸다.
  <Route key="schedule-root" path="schedule" element={<Navigate to="/schedule/personal" replace />} />,

  <Route
    key="schedule-personal"
    path="schedule/personal"
    element={<PrivateRoute menuCode={MENU.SCH_PERSONAL}><SchedulePage scope="personal" menuId={96} /></PrivateRoute>}
  />,
  <Route
    key="schedule-department"
    path="schedule/department"
    element={<PrivateRoute menuCode={MENU.SCH_DEPARTMENT}><SchedulePage scope="department" menuId={97} /></PrivateRoute>}
  />,
  <Route
    key="schedule-company"
    path="schedule/company"
    element={<PrivateRoute menuCode={MENU.SCH_COMPANY}><SchedulePage scope="company" menuId={98} /></PrivateRoute>}
  />,
];

export default scheduleRoutes;
